import { LoopWinsComponent } from "ags/components/loop-wins-component";
import { Contract } from "appworks/utils/contracts/contract";
import { Timer } from "appworks/utils/timer";
import { BaseAnimateSymbolBehaviour } from "slotworks/components/matrix/symbol/behaviours/base-animate-symbol-behaviour";

export class AgsBorderHighlightBehaviour extends BaseAnimateSymbolBehaviour {
    public cycle(): Contract<void> {
        return new Contract<void>((resolve) => {
            this.animate("_over", [this.defaultAnimation]).execute();

            // this.animation.parent.addChildAt(this.animation, 0); // Moves winbox to back

            Timer.setTimeout(() => {
                if (this.animation) {
                    this.animation.visible = false;
                }
                resolve(null);
            }, LoopWinsComponent.minCelebrationDuration);
        });
    }

    public highlight(): Contract<void> {
        return Contract.empty();
    }

    public win(): Contract<void> {
        return Contract.empty();
    }

}
